<img src="../../../../../assets/images/SPACE AR small.png" style="width:100px;margin-left:20px;"/>
<h1 mat-dialog-title>Enter Reason for Exemption</h1>
<div mat-dialog-content style="position:relative;top:-60px;">
    <div>
      <div class="row">
        <div class="col-12">
            <mat-form-field appearance="fill" style="width:100%">
                <mat-label>Comments</mat-label>
                <textarea matInput placeholder="Comments"  [(ngModel)]="comments"  maxlength="2048"></textarea>
            </mat-form-field>
        </div>
      </div>
    </div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false" >Cancel</button>
  <button mat-button [mat-dialog-close]="comments" cdkFocusInitial>Add Comments</button>
</div>
<p>Note: Adding comments here doesn't add this new parker.</p>
